const MenuSettingKey = {
    OPENING_BEHAVIOR: 'Menu Opening Behavior',
};

export default MenuSettingKey;
